import { createContext, useContext, useMemo, useState, type PropsWithChildren } from 'react'

import { useThrottle } from 'react-use'

import type { PossibleMonthlyInstallments } from './constants'
import { calculateInstallmentsValue } from './utils'

interface LoanSimulatorProvider {
  moneyAmount: number
  installments: PossibleMonthlyInstallments
  loanInstallmentsResult: number
  setMoneyAmount: (value: number) => void
  setInstallments: (value: PossibleMonthlyInstallments) => void
}
const LoanSimulatorContext = createContext<LoanSimulatorProvider>({} as LoanSimulatorProvider)

export const LoanSimulatorProvider = ({ children }: PropsWithChildren) => {
  const [moneyAmount, setMoneyAmount] = useState(150)
  const [installments, setInstallments] = useState<PossibleMonthlyInstallments>(6)

  const loanInstallmentsResult = useMemo(
    () => calculateInstallmentsValue(moneyAmount, installments),
    [moneyAmount, installments],
  )
  const loanInstallmentsResultThrottle = useThrottle(loanInstallmentsResult, 3000)

  return (
    <LoanSimulatorContext.Provider
      value={{
        moneyAmount,
        installments,
        loanInstallmentsResult: loanInstallmentsResultThrottle,
        setInstallments,
        setMoneyAmount,
      }}
    >
      {children}
    </LoanSimulatorContext.Provider>
  )
}

export const useLoanSimulatorProvider = () => useContext(LoanSimulatorContext)
